import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, TemplateRef, inject } from '@angular/core';
import { FormControl, FormGroupDirective } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AbstractControlComponent } from '../../classes/AbstractControlComponent';
import { DatePickerType } from '../../enums/date-picker-type.enum';
import { FormStatus } from '../../enums/form-status.enum';
import { FormGroupService } from '../../services/form-group.service';

@UntilDestroy()
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-time-picker-form-control',
	styleUrls: ['./time-picker-form-control.component.scss'],
	templateUrl: './time-picker-form-control.component.html',
	standalone: false,
})
export class TimePickerFormControlComponent extends AbstractControlComponent implements OnInit {
	private changeDetectorRef = inject(ChangeDetectorRef);
	private formGroupDirective = inject(FormGroupDirective);
	private macFormGroupService = inject(FormGroupService);

	DATE_PICKER_TYPE = DatePickerType;
	FORM_STATUS = FormStatus;

	formControl: FormControl;

	@Input() controlName: string;
	@Input() disableControl: boolean = undefined;
	@Input() helperText?: string | TemplateRef<any>;
	@Input() label?: string | TemplateRef<any>;
	@Input() max: string | null = null;
	@Input() min: string | null = null;
	@Input() placeholder = '';
	@Input() range = false;

	ngOnInit(): void {
		this.formControl = this.formGroupDirective.control.get(this.controlName) as FormControl;

		this.macFormGroupService.submit$.pipe(untilDestroyed(this)).subscribe(() => {
			FormGroupService.touchControl(this.formControl);
			this.changeDetectorRef.markForCheck();
		});
	}
}
